import { PaymentStatus } from './enums';
import { RecordData } from '../../helpers-classes';
import { BlueprintMetadataData, BlueprintMetadataDataIn } from './types';

export const blueprintMetadataDataData = (dataIn: Partial<BlueprintMetadataDataIn> = null): BlueprintMetadataData => {
	const rd = new RecordData<BlueprintMetadataDataIn>(dataIn);

	const record: BlueprintMetadataData = {
		estimateNumber: rd.useNewOrDefault('estimateNumber', ''),
		invoiceNumber: rd.useNewOrDefault('invoiceNumber', ''),
		workorderNumber: rd.useNewOrDefault('workorderNumber', ''),
		paymentStatus: rd.useNewOrDefault('paymentStatus', PaymentStatus.NotPaid),
		favorite: rd.useNewOrDefault('favorite', false),
		priority: rd.useNewOrDefault('priority', 0),
		renderingRawPath: rd.useNewOrDefault('renderingRawPath', ''),
		renderingAiPath: rd.useNewOrDefault('renderingAiPath', ''),
		renderingCanonical: rd.useNewOrDefault('renderingCanonical', 'raw'),
		renderingCapturedAt: rd.useNewOrDefault('renderingCapturedAt', ''),
		renderingKitchenSignature: rd.useNewOrDefault('renderingKitchenSignature', ''),
		savedKitchenSignature: rd.useNewOrDefault('savedKitchenSignature', '')
	};

	return record;
};
